<script setup lang="ts">
interface CTABlok {
    _uid: string;
    headline: string;
    subline: string;
    cta_text: string;
    cta_link: { cached_url: string; url: string };
    style: string;
}

defineProps<{ blok: CTABlok }>();

function resolveLink(link: { cached_url: string; url: string } | undefined): string {
    return link?.cached_url || link?.url || '#';
}

function trackClick(label: string) {
    if (typeof window !== 'undefined' && (window as any).dataLayer) {
        (window as any).dataLayer.push({
            event: 'cta_click',
            cta_label: label,
        });
    }
}
</script>

<template>
    <section
        v-editable="blok"
        class="py-16 xl:py-24"
        :class="blok.style === 'warm' ? 'bg-[#FCEEE6]' : blok.style === 'dark' ? 'bg-[#004646]' : 'bg-[#FCF7F4]'"
    >
        <div class="mx-auto max-w-2xl px-4 text-center">
            <h2
                class="mb-4 text-[28px] font-semibold leading-tight xl:mb-6 xl:text-4xl"
                :class="blok.style === 'dark' ? 'text-white' : 'text-[#004646]'"
            >
                {{ blok.headline }}
            </h2>
            <p
                v-if="blok.subline"
                class="mb-8 text-base font-normal xl:mb-10 xl:text-xl"
                :class="blok.style === 'dark' ? 'text-white/80' : 'text-[#393734]'"
            >
                {{ blok.subline }}
            </p>
            <a
                v-if="blok.cta_text"
                :href="resolveLink(blok.cta_link)"
                class="inline-block rounded-lg px-8 py-4 text-lg font-semibold transition hover:opacity-90"
                :class="
                    blok.style === 'dark'
                        ? 'bg-[#F08E59] text-white shadow-orange-button'
                        : 'bg-[#393734] text-white'
                "
                @click="trackClick(blok.cta_text)"
            >
                {{ blok.cta_text }}
            </a>
        </div>
    </section>
</template>
